import { render } from "./IncomeCategory.vue?vue&type=template&id=0da44e6a"
import script from "./IncomeCategory.vue?vue&type=script&lang=js"
export * from "./IncomeCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__